export default __webpack_public_path__ + "static/media/687.b2fc13fd.png";